import { toast, ToastContent, ToastContentProps, ToastOptions, TypeOptions } from 'react-toastify'
import { decorate, injectable } from 'inversify'
import { EToasterProps } from '../../UIContext'
import { Col } from '../../layout'

class ToastService {
    private static counter = 0

    public addToast(config: EToasterProps) {
        const { message, title, color, onClick, ...restOptions } = config

        const toastId = restOptions.toastId || `toast-${ToastService.counter++}`

        // Map our color prop to react-toastify's type
        let toastType: TypeOptions = 'default'
        if (color === 'success') toastType = 'success'
        else if (color === 'danger') toastType = 'error'
        else if (color === 'warning') toastType = 'warning'
        else if (color === 'info') toastType = 'info'

        // Build options with defaults that can be overridden
        const options: ToastOptions = {
            ...restOptions, // Spread all other react-toastify options
            type: toastType,
            toastId: toastId
        }

        // If onClick is provided, wrap content in a clickable div and handle the click
        if (onClick) {
            options.onClick = (e) => {
                onClick(e)
                toast.dismiss(toastId) // Auto-dismiss when clicked (like old behavior)
            }
            options.style = {
                cursor: 'pointer',
                ...options.style
            }
        }

        // Create content with optional title
        // needs to be a function: https://github.com/fkhadra/react-toastify/issues/224
        const content: ToastContent = (props: ToastContentProps) => (
            <Col className="pe-3">
                {title && <div className="mb-2 fw-bold">{title}</div>}
                <div>{message}</div>
            </Col>
        )

        // Call toast with the computed type
        toast(content, options)
    }
}

decorate(injectable(), ToastService)

export { ToastService }
